// Mock data for VikingFuneralPyres.com

export const mockFunerals = [
  {
    id: '1',
    name: 'Eric the Bold\'s Sendoff',
    songList: [
      { title: 'Immigrant Song', artist: 'Led Zeppelin' },
      { title: 'Thunderstruck', artist: 'AC/DC' },
      { title: 'Valhalla Calling', artist: 'Miracle of Sound' }
    ],
    quotes: [
      'Live boldly or die trying',
      'The brave may fall, but never yield',
      'Death is but the beginning of the greatest adventure'
    ],
    catering: {
      heineken: 200,
      mead: 50,
      roastedMeat: true,
      vikingFeast: true,
      additionalItems: 'Smoked salmon, honey cakes, wild berries'
    },
    vesselType: 'Original Viking',
    attendanceLevel: 'Tribe',
    location: {
      river: 'Hudson River, NY',
      waterfall: 'Niagara Falls'
    },
    createdAt: new Date().toISOString(),
    shareCode: 'VFP-ERIC-2024'
  },
  {
    id: '2',
    name: 'Freya\'s Fire Festival',
    songList: [
      { title: 'The Final Countdown', artist: 'Europe' },
      { title: 'Uprising', artist: 'Muse' },
      { title: 'Warriors', artist: 'Imagine Dragons' }
    ],
    quotes: [
      'She conquered life with grace and fury',
      'Not all who wander are lost',
      'The fire inside burns eternal'
    ],
    catering: {
      heineken: 150,
      mead: 75,
      roastedMeat: true,
      vikingFeast: true,
      additionalItems: 'Fresh bread, aged cheese, spiced wine'
    },
    vesselType: 'Modern Viking',
    attendanceLevel: 'Country',
    location: {
      river: 'Mississippi River',
      waterfall: 'Multnomah Falls, Oregon'
    },
    createdAt: new Date().toISOString(),
    shareCode: 'VFP-FREYA-2024'
  }
];

export const mockLocations = [
  {
    type: 'river',
    name: 'Hudson River',
    state: 'New York',
    mapLink: 'https://maps.google.com/?q=Hudson+River+NY'
  },
  {
    type: 'river',
    name: 'Mississippi River',
    state: 'Louisiana',
    mapLink: 'https://maps.google.com/?q=Mississippi+River+LA'
  },
  {
    type: 'river',
    name: 'Columbia River',
    state: 'Oregon',
    mapLink: 'https://maps.google.com/?q=Columbia+River+OR'
  },
  {
    type: 'waterfall',
    name: 'Niagara Falls',
    state: 'New York',
    mapLink: 'https://maps.google.com/?q=Niagara+Falls+NY'
  },
  {
    type: 'waterfall',
    name: 'Multnomah Falls',
    state: 'Oregon',
    mapLink: 'https://maps.google.com/?q=Multnomah+Falls+OR'
  },
  {
    type: 'waterfall',
    name: 'Yosemite Falls',
    state: 'California',
    mapLink: 'https://maps.google.com/?q=Yosemite+Falls+CA'
  }
];

export const attendanceLevels = [
  {
    name: 'Neighborhood',
    capacity: '50-100',
    description: 'An intimate gathering for close friends and family',
    icon: 'Home',
    price: '$2,500'
  },
  {
    name: 'Tribe',
    capacity: '100-300',
    description: 'A community celebration with extended circles',
    icon: 'Users',
    price: '$7,500'
  },
  {
    name: 'Country',
    capacity: '300+',
    description: 'An epic legendary sendoff worthy of sagas',
    icon: 'Globe',
    price: '$15,000+'
  }
];

export const popularSongs = [
  { title: 'Immigrant Song', artist: 'Led Zeppelin' },
  { title: 'Thunderstruck', artist: 'AC/DC' },
  { title: 'The Final Countdown', artist: 'Europe' },
  { title: 'Valhalla Calling', artist: 'Miracle of Sound' },
  { title: 'Warriors', artist: 'Imagine Dragons' },
  { title: 'Eye of the Tiger', artist: 'Survivor' },
  { title: 'We Will Rock You', artist: 'Queen' },
  { title: 'Enter Sandman', artist: 'Metallica' },
  { title: 'Highway to Hell', artist: 'AC/DC' },
  { title: 'Don\'t Stop Me Now', artist: 'Queen' }
];

export const inspirationalQuotes = [
  'Live boldly or die trying',
  'The brave may fall, but never yield',
  'Death is but the beginning of the greatest adventure',
  'Valhalla awaits the fearless',
  'Not all who wander are lost',
  'The fire inside burns eternal',
  'Life is a story worth telling',
  'From ashes we rise',
  'The journey continues beyond the flames',
  'Honor, courage, glory'
];